import { EllipsedText, FlexColumn } from '@gorila-shared-ui/components';
import { Avatar } from 'baseui/avatar';
import { LabelSmall } from 'baseui/typography';
import { useRecoilValue } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import { isAllWorkspacesSelect, sidenavIsPinnedState, workspaceState } from '../../storage/app';

export function WorkspaceAvatar() {
  const { css, theme } = useStyles();
  const workspace = useRecoilValue(workspaceState);
  const isAllWorkspaces = useRecoilValue(isAllWorkspacesSelect);
  const sidenavIsPinned = useRecoilValue(sidenavIsPinnedState);

  return (
    <FlexColumn
      centered
      classNames={css({ padding: theme.sizing.scale600 })}
    >
      <Avatar
        name={workspace?.name}
        size={sidenavIsPinned ? 'scale1600' : 'scale850'}
        src={workspace && !isAllWorkspaces ? workspace.logo : '/img/logo_circulo.svg'}
      />
      {sidenavIsPinned && (
        <LabelSmall className={css({ textAlign: 'center' })}>
          <EllipsedText maxLines={2}>{workspace?.name || '...'}</EllipsedText>
        </LabelSmall>
      )}
    </FlexColumn>
  );
}
